export const csrfToken: () => string | null = () => {
  const meta = document.querySelector<HTMLMetaElement>("meta[name=csrf-token]");
  return meta && meta.content;
};
